import { defaultRetryOptions } from '../util/fetchWithRetry';

export default function retry(action: any, retries: number) {
  if (retries >= 0 && retries < defaultRetryOptions.length) {
    return defaultRetryOptions[retries];
  }
  return null;
}
